import React, { Component } from 'react';
import { connect } from 'react-redux';
import Echo from 'laravel-echo';
import * as Maps from '../store/map';

class LsportsAMQ extends Component {
    componentDidMount() {
        window.Pusher = require('pusher-js');

        var options =
            process.env.REACT_APP_ENV === 'dev'
                ? {
                      broadcaster: 'pusher',
                      key: process.env.REACT_APP_PUSHER_APP_KEY,
                      cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
                      wsHost: window.location.hostname,
                      wsPort: process.env.REACT_APP_PUSHER_APP_PORT,
                      // disableStats: true,
                      // enabledTransports: ['ws', 'xhr_streaming'],
                      // disabledTransports: ['xhr_streaming']
                  }
                : {
                      broadcaster: 'pusher',
                      key: process.env.REACT_APP_PUSHER_APP_KEY,
                      cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
                      wsHost: process.env.REACT_APP_PUSHER_APP_WS_HOST,
                      //      wsPort: 6001,
                      //      wssPort: 6001,
                      disableStats: true,
                      enabledTransports: ['ws', 'wss', 'xhr_streaming'],
                      disabledTransports: ['xhr_streaming'],
                  };

        window.Echo = new Echo(options);

        window.Echo.channel('rmq-prematch').listen('RMQPrematchMessage', (e) => {
            //this.props.updatePrematchRMQEvent(JSON.parse(e.message));
        });

        window.Echo.channel('rmq-inplay').listen('RMQInplayMessage', (e) => {});
    }

    render() {
        return <React.Fragment children={this.props.children} />;
    }
}

export default connect(Maps.mapLSportsStateToProps, Maps.mapLSportsDispatchToProps)(LsportsAMQ);
